module.exports = __webpack_public_path__ + "img/step1-n.ade2288e.png";